import { render, staticRenderFns } from "./InformacionRecuperadaEmpresa.vue?vue&type=template&id=32163f2a"
import script from "./InformacionRecuperadaEmpresa.vue?vue&type=script&lang=js"
export * from "./InformacionRecuperadaEmpresa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports